"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverflowCarousel = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _button = _interopRequireDefault(require("@ingka/button"));
var _chevronRightSmall = _interopRequireDefault(require("@ingka/ssr-icon/paths/chevron-right-small"));
var _chevronLeftSmall = _interopRequireDefault(require("@ingka/ssr-icon/paths/chevron-left-small"));
var _classnames = _interopRequireDefault(require("classnames"));
var _bezierEasing = _interopRequireDefault(require("bezier-easing"));
var _debounce = _interopRequireDefault(require("@ingka/carousel-shared/utils/debounce"));
var _smoothScroll = _interopRequireDefault(require("@ingka/carousel-shared/utils/smoothScroll"));
var _rtlScrollLeft = require("@ingka/carousel-shared/utils/rtlScrollLeft");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const _getVisibleMinMax = (indexes, minmax) => {
  if (indexes === undefined || indexes.length === 0) {
    return null;
  }
  return Math[minmax].apply(Math, indexes);
};
const OverflowCarousel = props => {
  const {
    children,
    prefix = '',
    id = 'default',
    className,
    hasNoControls,
    controlBtnType,
    ariaLabelRightBtn,
    ariaLabelLeftBtn,
    onBtnRightClick,
    onBtnLeftClick,
    rtl,
    slideIndex = null
  } = props;
  const scrollingContainer = (0, _react.useRef)(null);
  const slideStateCache = _react.default.useRef([]);
  const [isFirstSlide, setIsFirstSlide] = (0, _react.useState)(true);
  const [isLastSlide, setIsLastSlide] = (0, _react.useState)(true);
  const [isScrolling, setIsScrolling] = (0, _react.useState)(false);
  const [rtlScrollType, setRtlScrollType] = (0, _react.useState)(null);
  const [swipeOnly, setSwipeOnly] = (0, _react.useState)(false);
  const [firstTouchEvent, setFirstTouchEvent] = (0, _react.useState)(false);
  const [intersectionObserverDisabled, setIntersectionObserverDisabled] = (0, _react.useState)(false);
  const [slideStates, setSlideStates] = (0, _react.useState)({
    visibleIndexes: [],
    visibleSlides: [],
    partiallyVisibleIndexes: [],
    partiallyVisibleSlides: []
  });
  const [slidesArray, setSlidesArray] = (0, _react.useState)([]);
  const previousBtnId = `${prefix}overflow-carousel__${id}-prev-btn`;
  const nextBtnId = `${prefix}overflow-carousel__${id}-next-btn`;
  let _visibleSlides = [];
  let _partiallyVisibleSlides = [];
  const nextTarget = () => {
    if (slideStates.visibleIndexes.length === 0 && slideStates.partiallyVisibleIndexes) {
      const nextIndex = _getVisibleMinMax(slideStates.partiallyVisibleIndexes, 'max') + 1;
      if (nextIndex > slidesArray.length - 1) {
        return slidesArray[nextIndex - 1];
      }
      return slidesArray[nextIndex];
    }
    if (slidesArray[_getVisibleMinMax(slideStates.visibleIndexes, 'max')] === null) {
      return slidesArray[_getVisibleMinMax(slideStates.partiallyVisibleIndexes, 'max')];
    }
    return slidesArray[_getVisibleMinMax(slideStates.visibleIndexes, 'max') + 1];
  };
  const prevTarget = () => {
    if (slideStates.visibleIndexes.length === 0 && slideStates.partiallyVisibleIndexes) {
      const prevIndex = _getVisibleMinMax(slideStates.partiallyVisibleIndexes, 'min') - 1;
      if (prevIndex < 0) {
        return slidesArray[0];
      }
      return slidesArray[prevIndex];
    }
    if (slidesArray[_getVisibleMinMax(slideStates.visibleIndexes, 'min')] === null) {
      return slidesArray[_getVisibleMinMax(slideStates.partiallyVisibleIndexes, 'min')];
    }
    return slidesArray[_getVisibleMinMax(slideStates.visibleIndexes, 'min') - 1];
  };
  const isFirstSlideVisible = () => {
    if (rtl ? rtlScrollType === 'reversed' && scrollingContainer.current.scrollLeft === maxScrollWidth() : scrollingContainer.current.scrollLeft === 0) {
      return true;
    }
    if (slideStates.visibleSlides.indexOf(slidesArray[0]) > -1) {
      return true;
    }
    return false;
  };
  const isLastSlideVisible = () => {
    if (slideStates.visibleSlides.indexOf(lastSlide) > -1) {
      return true;
    }
    if (rtl ? rtlScrollType === 'reversed' && scrollingContainer.current.scrollLeft === 0 : scrollingContainer.current.scrollLeft === maxScrollWidth()) {
      return true;
    }
    return false;
  };
  const lastSlide = slidesArray[slidesArray.length - 1];
  const maxScrollWidth = () => {
    if (!scrollingContainer.current) {
      return Infinity;
    }
    return scrollingContainer.current.scrollWidth - scrollingContainer.current.offsetWidth;
  };
  const getPreviousScroll = target => {
    return (0, _rtlScrollLeft.scrollLeftPrevCustom)(rtl, rtlScrollType, target, scrollingContainer.current);
  };
  const getNextScroll = target => {
    return (0, _rtlScrollLeft.scrollLeftNextCustom)(rtl, rtlScrollType, target, scrollingContainer.current);
  };
  const easing = (elapsed, offset, gap, duration) => {
    const f = (0, _bezierEasing.default)(0.4, 0, 0.4, 1);
    const progress = elapsed / duration;
    return gap * f(progress) + offset;
  };
  const observeSlides = (0, _react.useCallback)((entries, observer) => {
    entries.forEach(entry => {
      const validObserver = observer && observer.thresholds;
      if (validObserver && entry.intersectionRatio >= observer.thresholds[1]) {
        if (_visibleSlides.indexOf(entry.target) === -1) {
          _visibleSlides.push(entry.target);
        }
      } else {
        _visibleSlides = _visibleSlides.filter(item => item !== entry.target);
      }
      if (validObserver && entry.intersectionRatio >= observer.thresholds[0]) {
        if (_partiallyVisibleSlides.indexOf(entry.target) === -1) {
          _partiallyVisibleSlides.push(entry.target);
        }
      } else {
        _partiallyVisibleSlides = _partiallyVisibleSlides.filter(item => item !== entry.target);
      }
    });
    setSlideStates({
      visibleIndexes: _visibleSlides.map(visible => slidesArray.indexOf(visible)),
      visibleSlides: _visibleSlides,
      partiallyVisibleIndexes: _partiallyVisibleSlides.map(visible => slidesArray.indexOf(visible)),
      partiallyVisibleSlides: _partiallyVisibleSlides
    });
  });
  const scrollToTarget = (0, _react.useCallback)(nextSlide => {
    setIsScrolling(true);
    (0, _smoothScroll.default)(scrollingContainer.current, 'scrollLeft', nextSlide, easing, 200, () => {
      setIsScrolling(false);
    });
  }, []);
  const onButtonClick = (0, _react.useCallback)(direction => {
    if (isScrolling) return;
    const nextSlide = direction === 'right' ? getNextScroll(nextTarget()) : getPreviousScroll(prevTarget());
    scrollToTarget(nextSlide);
    if (direction === 'right' && onBtnRightClick) {
      onBtnRightClick();
    }
    if (direction === 'left' && onBtnLeftClick) {
      onBtnLeftClick();
    }
  });
  const onFirstTap = (0, _react.useCallback)(e => {
    if (firstTouchEvent) return;
    if (e.target.parentNode.classList.contains(`${prefix}overflow-carousel__button`)) {
      setFirstTouchEvent(true);
      setSwipeOnly(false);
    }
  });
  const onFirstSwipe = (0, _react.useCallback)(e => {
    if (firstTouchEvent) return;
    setFirstTouchEvent(true);
    if (!e.target.parentNode.classList.contains(`${prefix}overflow-carousel__button`)) {
      setSwipeOnly(true);
    }
  });
  const resizeEventCallback = (0, _react.useCallback)((0, _debounce.default)(() => {
    if (slideStates.partiallyVisibleSlides === undefined || slideStates.partiallyVisibleSlides.length === 0) return;
    setIsFirstSlide(isFirstSlideVisible);
    setIsLastSlide(isLastSlideVisible);
  }, 250));
  (0, _react.useEffect)(() => {
    const parentNode = scrollingContainer.current.parentNode;
    parentNode.addEventListener('touchstart', onFirstTap, {
      once: true
    });
    parentNode.addEventListener('touchmove', onFirstSwipe, {
      once: true
    });
    return () => {
      parentNode.removeEventListener('touchstart', onFirstTap);
      parentNode.removeEventListener('touchmove', onFirstSwipe);
    };
  }, [firstTouchEvent, onFirstSwipe]);
  (0, _react.useEffect)(() => {
    if (slideStates.partiallyVisibleSlides === undefined || slideStates.partiallyVisibleSlides.length === 0) return;
    setIsFirstSlide(isFirstSlideVisible);
    setIsLastSlide(isLastSlideVisible);
  }, [slideStates, rtl]);
  const setCacheVisibleSlides = (0, _react.useCallback)(e => {
    let keyDownSlides;
    setSlideStates(state => {
      keyDownSlides = state;
      return state;
    });
    slideStateCache.current = keyDownSlides;
  }, []);
  const focusEventCallback = (0, _react.useCallback)(e => {
    if (slideStateCache.current.visibleSlides && slideStateCache.current.visibleSlides.indexOf(e.target) !== -1) return;
    if (!['Tab', 'ArrowRight', 'ArrowLeft'].includes(e.key)) return;
    const isForward = !e.shiftKey && e.key === 'Tab' || e.key === 'ArrowRight' && !rtl || e.key === 'ArrowLeft' && rtl;
    const nextSlide = isForward ? getNextScroll(e.target) : getPreviousScroll(e.target);
    scrollToTarget(nextSlide * (rtl ? -1 : 1));
  }, []);
  (0, _react.useEffect)(() => {
    const arr = [].slice.call(scrollingContainer.current.children);
    arr.forEach(slide => !!slide && slide.addEventListener('keyup', focusEventCallback));
    arr.forEach(slide => !!slide && slide.addEventListener('keydown', setCacheVisibleSlides));
    setSlidesArray(arr);
    window.addEventListener('resize', resizeEventCallback);
    return () => {
      window.removeEventListener('resize', resizeEventCallback);
      arr.forEach(slide => !!slide && slide.removeEventListener('keyup', focusEventCallback));
      arr.forEach(slide => !!slide && slide.removeEventListener('keydown', setCacheVisibleSlides));
    };
  }, [_react.default.Children.toArray(children).length]);
  (0, _react.useEffect)(() => {
    if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window) {
      const visibleSlideObserver = new IntersectionObserver(observeSlides, {
        root: scrollingContainer.current,
        threshold: [0.99, 0.001],
        rootMargin: '1px'
      });
      slidesArray.forEach(slide => !!slide && visibleSlideObserver.observe(slide));
      setIntersectionObserverDisabled(false);
      return () => {
        visibleSlideObserver.disconnect();
      };
    } else {
      setIntersectionObserverDisabled(true);
    }
  }, [slidesArray]);
  (0, _react.useEffect)(() => {
    setRtlScrollType((0, _rtlScrollLeft.scrollLeftDirection)());
  }, [rtl]);
  (0, _react.useEffect)(() => {
    if (Number.isNaN(Number(slideIndex)) || slidesArray.length === 0 || slideIndex === null) return;
    const clampedSlideIndex = Math.max(Math.min(slideIndex, slidesArray.length - 1), 0);
    const nextSlide = getNextScroll(slidesArray[clampedSlideIndex]);
    scrollToTarget(nextSlide);
  }, [slidesArray, slideIndex, rtl]);
  const baseClass = `${prefix}overflow-carousel`;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(baseClass, intersectionObserverDisabled && `${baseClass}--intersection-observer-disabled`, className)
  }, !hasNoControls && !swipeOnly && _react.default.createElement(_button.default, {
    id: previousBtnId,
    "aria-controls": `${baseClass}__${id}-prev-btn`,
    prefix: prefix,
    xsmallIconOnly: true,
    iconOnly: true,
    inverseTheme: true,
    ssrIcon: _chevronLeftSmall.default,
    type: controlBtnType,
    "aria-label": ariaLabelLeftBtn,
    className: (0, _classnames.default)(`${baseClass}__button`, isFirstSlide && `${baseClass}__button--hidden`),
    onClick: () => onButtonClick('left')
  }), _react.default.createElement("div", {
    className: `${baseClass}__content`,
    ref: scrollingContainer
  }, children), !hasNoControls && !swipeOnly && _react.default.createElement(_button.default, {
    id: nextBtnId,
    "aria-controls": `${baseClass}__${id}-next-btn`,
    prefix: prefix,
    xsmallIconOnly: true,
    iconOnly: true,
    inverseTheme: true,
    ssrIcon: _chevronRightSmall.default,
    type: controlBtnType,
    "aria-label": ariaLabelRightBtn,
    className: (0, _classnames.default)(`${baseClass}__button`, `${baseClass}__button--right`, isLastSlide && `${baseClass}__button--hidden`),
    onClick: () => onButtonClick('right')
  }));
};
exports.OverflowCarousel = OverflowCarousel;
OverflowCarousel.defaultProps = {
  id: 'default',
  hasNoControls: false,
  prefix: '',
  ariaLabelLeftBtn: 'See previous items',
  ariaLabelRightBtn: 'See next items',
  controlBtnType: 'primary'
};